import { render, staticRenderFns } from "./FooterWeShope.vue?vue&type=template&id=1e66e414&"
import script from "./FooterWeShope.vue?vue&type=script&lang=ts&"
export * from "./FooterWeShope.vue?vue&type=script&lang=ts&"
import style0 from "./FooterWeShope.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports